module.exports = __webpack_public_path__ + "static/SCSS-29333438d1b959f64462ea8e4e3718f6.png";